import browser from "./browser"
import notFound from "./notFound"

export default {
  browser,
  notFound,
}
